import numeral from 'numeral';

const result = (format, key = '.00') => {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
};

export const formatNumber = (v) => numeral(v).format();

export const formatCurrency = (v) => {
  const format = v ? numeral(v).format('$0,0.00') : '$0';

  return result(format, '.00');
};

export const formatPercent = (v) => {
  const format = v ? numeral(Number(v) / 100).format('0.00 %') : '0 %';

  return result(format, '.00');
};

export const formatDuration = (minutes) => {
  if (!minutes && minutes !== 0) return '00:00:00';

  const totalSeconds = Math.round(Number(minutes) * 60);

  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  const pad = (n) => String(n).padStart(2, '0');

  return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
};
